import React from "react";
import {useTranslation, useI18next} from "gatsby-plugin-react-i18next";
import { isRtlLanguage } from "../utils/rtl";

const SUCCESS_LABELS = {
	en: "Successfully:",
	et: "Edukalt:",
	ru: "Успешно:",
	he: "הצלחה:",
};

const SuccessMessage = (props) => {
	const {t} = useTranslation();
	const {language} = useI18next();
	const isRtl = isRtlLanguage(language);
	const translated = t("success_label");
	const label =
		translated && translated !== "success_label"
			? translated
			: SUCCESS_LABELS[language] || SUCCESS_LABELS.en;

	return (
		<div className="w-full max-w-sm border rounded-md h-12 text-sm flex items-center">
			<div
				className={`bg-green h-full w-2 justify-self-center ${isRtl ? "rounded-r-md" : "rounded-l-md"}`}
			></div>
			<p className={`${isRtl ? "mr-3" : "ml-3"} text-gray`}>
				<span className={"text-green uppercase font-bold"}>{label}</span>{" "}
				{props.message}
			</p>
		</div>
	);
};

export default SuccessMessage;
